module.exports = __webpack_public_path__ + "static/L2_ux_5_1_eg-c579dd19942005edcfa6957d03c136b1.png";